module.exports = __webpack_public_path__ + "static/media/medica.98fba60b.svg";